<img *ngIf="imageLink !== ''" [src]="imageLink" [alt]="iconAlt" [width]="size" />